import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { diffWords } from 'diff';
import Button from '../../components/UI/Button';
import './TextCompare.css';

const TextCompare = () => {
    const [text1, setText1] = useState('');
    const [text2, setText2] = useState('');
    const [diffResult, setDiffResult] = useState([]);

    useEffect(() => {
        if (text1 || text2) {
            const diff = diffWords(text1, text2);
            setDiffResult(diff);
        } else {
            setDiffResult([]);
        }
    }, [text1, text2]);

    return (
        <div className="tool-page container">
            <Helmet>
                <title>Text Compare - Diff Checker Tool | OnlineToolSphere</title>
                <meta name="description" content="Compare two text files online and find the differences. Highlight added and removed text instantly." />
                <meta property="og:title" content="Text Compare - Diff Checker Tool | OnlineToolSphere" />
                <meta property="og:description" content="Compare two text files online and find the differences. Highlight added and removed text instantly." />
                <meta property="og:url" content="https://onlinetoolsphere.com/tools/text-compare/" />
                <meta name="twitter:title" content="Text Compare - Diff Checker Tool | OnlineToolSphere" />
                <meta name="twitter:description" content="Compare two text files online and find the differences. Highlight added and removed text instantly." />
            </Helmet>
            <div className="tool-header">
                <h1 className="text-gradient">Text Compare</h1>
                <p className="tool-subtitle">Compare two texts and find the differences.</p>
            </div>

            <div className="compare-grid">
                <div className="input-column">
                    <div className="pane-header">Original Text</div>
                    <textarea
                        className="compare-input"
                        value={text1}
                        onChange={(e) => setText1(e.target.value)}
                        placeholder="Paste original text here..."
                    />
                </div>
                <div className="input-column">
                    <div className="pane-header">Modified Text</div>
                    <textarea
                        className="compare-input"
                        value={text2}
                        onChange={(e) => setText2(e.target.value)}
                        placeholder="Paste modified text here..."
                    />
                </div>
            </div>

            <div className="diff-output">
                <div className="pane-header">Differences</div>
                <div className="diff-viewer">
                    {diffResult.map((part, index) => {
                        const color = part.added ? 'var(--diff-add-bg)' : part.removed ? 'var(--diff-rem-bg)' : 'transparent';
                        const textColor = part.added ? 'var(--diff-add-text)' : part.removed ? 'var(--diff-rem-text)' : 'var(--text-main)';
                        return (
                            <span key={index} style={{ backgroundColor: color, color: textColor }}>
                                {part.value}
                            </span>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default TextCompare;
